import { Component } from '@angular/core';
import { Platform, ToastController } from '@ionic/angular';

import { FcmService } from './services/fcm.service';
import { SwUpdate } from '@angular/service-worker';
import { UsersFirebaseService } from './services/firebase/users-firebase.service';
import { AuthProvider } from '@mobile/providers/auth';
import { filter, first, switchMap, tap } from 'rxjs/operators';
import { User } from './shared/types/user.types';
import { EnderecosType } from './shared/types/enderecos.types';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private fcmService: FcmService,
    private toastCtrl: ToastController,
    private swUpdate: SwUpdate,
    private authProvider: AuthProvider,
    private usersFirebaseService: UsersFirebaseService,
    private storage: Storage,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Trigger the push setup
      this.fcmService.initPush();
      this.subscribePush();
      this.checkForUpdates();
      this.runAddressMigrationOnLogin();
    });
  }

  async subscribePush() {
    const messages = await this.fcmService.getMessages();

    if (messages && messages.notifications) {
      console.log("subscribePush data",  messages.notifications);
      messages.notifications.forEach(data => {

        this.toastCtrl.create({
          header: data.title,
          message: data.body,
          duration: 2000,
          position: "bottom",
          color: "danger"
        }).then((toast) => toast.present());
      });

    }

  }

  checkForUpdates() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(async () => {
        const toast = await this.toastCtrl.create({
          message: 'Uma nova versão está disponível!',
          position: 'bottom',
          buttons: [
            {
              text: 'Atualizar',
              role: 'cancel',
              handler: () => {
                // Recarrega a página para ativar a nova versão do service worker
                window.location.reload();
              }
            }
          ]
        });

        await toast.present();
      });
    }
  }

    /**
   * Escuta o estado de autenticação e dispara a migração de endereços
   * para o usuário logado, caso ainda não tenha sido feita.
   */
  private runAddressMigrationOnLogin(): void {
    // O observable 'authState' está em 'afAuth' dentro do AuthProvider
    this.authProvider.afAuth.authState
      .pipe(
        // Filtra para continuar apenas quando um usuário estiver logado
        filter(user => !!user),
        // Busca os dados completos do usuário no Firestore
        switchMap(authUser => this.usersFirebaseService.getUser(authUser.uid)),
        // Pega apenas a primeira emissão para não re-executar a cada mudança no documento do usuário
        first(user => user !== undefined),
        // Executa a lógica de migração
        tap(async (user: User) => {
          // Verifica se a migração é necessária (campo 'locais' não existe)
          if (user && typeof user.locais === 'undefined') {
            console.log(`[AppComponent] Iniciando migração de endereços para o usuário ${user.uid}`);

            // 1. Busca os endereços da estrutura antiga diretamente do Storage local.
            const oldEnderecos: EnderecosType = await this.storage.get('endereco');

            // 2. Se existirem, executa a migração
            if (oldEnderecos && oldEnderecos.cadastrados?.length > 0) {
              await this.usersFirebaseService.migrateUserAddresses(user.uid, oldEnderecos);
              console.log(`[AppComponent] Migração de endereços para o usuário ${user.uid} concluída.`);
              await this.storage.remove('endereco'); // Remove a chave antiga para limpar o storage.
            }
          }
        })
      )
      .subscribe();
  }

}
